import * as z from 'zod';

import { BuydownType } from '../loan/Loan';
import { zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UpdateLoanBoardedDatesEvent = BaseLoanEvent.extend({
  type: z.literal('updateLoanBoardedDates'),
  fundingDate: zodDateOrString,
  firstPaymentDate: zodDateOrString,
  firstCollectedPaymentDate: zodDateOrString,
  annualInterestRate: z.coerce.number().nonnegative().optional(),
  maturityDate: zodDateOrString,
  loanClosingDate: zodDateOrString.optional(),
  currentOutstandingAmount: z.number(),
  buydownType: BuydownType.nullish(),
  hasInterestReserve: z.boolean().optional(),
  initialReserveBalance: z.number().nonnegative().optional(),
});
export type UpdateLoanBoardedDatesEvent = z.infer<typeof UpdateLoanBoardedDatesEvent>;
